<template>
    <div class="table">
        <!-- 查询条件 -->
        <div style="margin-bottom:10px;">
            <el-select v-model="form.deptId" placeholder="请选择学校" style="width:160px;" @change="common.page=1;getData()">
                <el-option
                    v-for="item in depts"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id">
                </el-option>
            </el-select>
            &nbsp;
            <el-input v-model="form.name" placeholder="学生姓名" style="width:160px;" clearable></el-input>
            &nbsp;
            <el-input v-model="form.gradeName" placeholder="年级名称" style="width:160px;" clearable></el-input>
            &nbsp;
            <el-input v-model="form.className" placeholder="班级名称" style="width:160px;" clearable></el-input>
            &nbsp;
            <el-button type="primary" icon="search" @click="common.page=1;getData()">查询</el-button>
        </div>

        <el-table
            :data="data"
            style="width:100%;margin-bottom:20px;"
            height="550"
            v-loading="loading"
            element-loading-text="数据正在加载中..."
            element-loading-background="rgba(255,255,255,0.7)"
            border>
            <el-table-column type="index" label="序号" width="55" :index="indexMethod"></el-table-column>
            <el-table-column prop="name" label="学生姓名" :show-overflow-tooltip="true"></el-table-column>
            <el-table-column prop="classNo" label="座位号"  width="60"></el-table-column>
            <el-table-column prop="gradeName" label="年级名称" :show-overflow-tooltip="true"></el-table-column>
            <el-table-column prop="className" label="班级名称" :show-overflow-tooltip="true"></el-table-column>
            <el-table-column prop="exchangeScore" label="总共-可兑换星" width="120"></el-table-column>
            <el-table-column prop="exchangeDscore" label="德育-可兑换星" width="120"></el-table-column>
            <el-table-column prop="exchangeZscore" label="智育-可兑换星" width="120"></el-table-column>
            <el-table-column prop="exchangeTscore" label="体育-可兑换星" width="120"></el-table-column>
            <el-table-column prop="exchangeMscore" label="美育-可兑换星" width="120"></el-table-column>
            <el-table-column prop="exchangeLscore" label="劳育-可兑换星" width="120"></el-table-column>
        </el-table>

        <div class="pagination">
            <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="common.page"
                :page-size="common.pageSize"
                :page-sizes="common.allSizes"
                layout="total,sizes,prev,pager,next,jumper"
                :total="common.total">
            </el-pagination>
        </div>
    </div>
</template>

<script>
    import http from '../../../../common/http';

    export default {
        name: "CoinExchangeList",
        data() {
            return {
                loading: false,
                common: {
                    total: 0,
                    pageSize: 20,
                    page: 1,
                    allSizes: [20, 50, 100]
                },
                form: {
                    deptId: "",
                    name: "",
                    gradeName: "",
                    className: ""
                },
                depts: [],
                data: []
            }
        },
        created() {
            this.getDeptData();
        },
        methods: {
            indexMethod(index) {
                return (this.common.page - 1) * this.common.pageSize + (index + 1);
            },
            getDeptData() {
                let url = this.listDeptUrl;
                let data = { parentId: "0" };
                this.apiPost(url, data).then((res) => {
                    if (res.status == 200) {
                        this.depts = res.data.list;
                        if (this.depts.length > 0) {
                            this.form.deptId = this.depts[0].id;
                        }
                        this.getData();
                    } else {
                        this.$commonFn.showTip(res.message, 3);
                    }
                }, (err) => { console.log(err); });
            },
            getData() {
                this.loading = true;
                let url = this.studentExchangeScoreListUrl;
                let data = {
                    isPage: 1,
                    page: this.common.page,
                    limit: this.common.pageSize,
                    deptId: this.form.deptId,
                    name: this.form.name,
                    gradeName: this.form.gradeName,
                    className: this.form.className
                };
                this.apiPost(url, data).then((res) => {
                    if (res.status == 200) {
                        this.data = res.data.list;
                        this.common.total = res.data.total;
                    } else {
                        this.$commonFn.showTip(res.message, 3);
                    }
                    this.loading = false;
                }, (err) => {
                    console.log(err);
                    this.loading = false;
                });
            },
            handleSizeChange(val) {
                this.common.pageSize = val;
                this.common.page = 1;
                this.getData();
            },
            handleCurrentChange(val) {
                this.common.page = val;
                this.getData();
            }
        },
        mixins: [http]
    }
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/page/schoolCoin/coinExchangeList/list.vue